import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TipoDocumentos } from '../models/tipo-documento.model';
import { Parentescos } from '../models/parentesco.model';
import { Solicitantes } from '../models/solicitante.model';
import { environment } from 'src/environments/environment';
import { ParametrosGc } from '../models/parametros-gc.model';
import { DocumentosParentesco } from '../models/docs-parentesco.model';
import { Retorno } from '../models/retorno.model';
import { Tipos } from '../models/tipos';
import { BandejaDocumento, BandejaDocumentos } from '../models/bandeja-documentos';
import { ArchivoDocumento, DocumnetoAdjunto, ResponseBack, RespuestaProcedimiento } from '../models/archivo-documento';
import { Bandeja, BandejaSolicitante } from '../models/bandeja';

@Injectable({
  providedIn: "root",
})
export class FinanciamientoApiService {
  financiamiento = "/financiamiento/reusable";
  //httpOptions; any;
  private SERVER_URL = environment.api;

  constructor(private httpClient: HttpClient) {
    /*
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    */
  }


  public getParametrosGc(data: any) {
    const formData = new FormData();
    formData.append("clase", data.clase);
    formData.append("modulo", data.modulo);
    formData.append("categoria", data.categoria);

    return this.httpClient.post<ParametrosGc>(this.SERVER_URL + this.financiamiento + "/parametrosGc",
      formData
    );
  }

  public getTipos(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
        //'username': environment.login.username,
        //'password': environment.login.password
      })
    };


    const formData = new FormData();
    formData.append("tipoTitulo", data.tipoTitulo);

    //formData.append("username", environment.login.username);
    //formData.append("password", environment.login.password);


    //let formData: any = {
    //  tipoTitulo: data.tipoTitulo,
    //};

    //let params = `?username=${environment.login.username}&password=${environment.login.password}`;
    //console.log("params",params);
    return this.httpClient.post<Tipos>(this.SERVER_URL + this.financiamiento + "/tipos", formData);
  }

  public getTipoDocumentos() {
    return this.httpClient.get<TipoDocumentos>(this.SERVER_URL + this.financiamiento + "/tipoDocumento", {});
  }

  public getParentescos() {
    return this.httpClient.get<Parentescos>(
      this.SERVER_URL + this.financiamiento + "/parentesco",
      {}
    );
  }

  public getSolicitante(data: any) {
    const formData = new FormData();
    formData.append("numSuministro", data.numSuministro);
    formData.append("tipDocumento", data.tipDocumento);
    formData.append("numDocumento", data.numDocumento);
    formData.append("tipTramite", data.tipTramite);
    return this.httpClient.post<Solicitantes>(
      this.SERVER_URL + this.financiamiento + "/solicitante",
      formData
    );
  }

  public getDocsParentesco(data: any) {
    const formData = new FormData();
    formData.append("parentescoCod", data.parentescoCod);
    return this.httpClient.post<DocumentosParentesco>(
      this.SERVER_URL + this.financiamiento + "/documentosParentesco",
      formData
    );
  }

  /*
  public getDescargarArchivo(data: any) {
    const formData = new FormData();
    formData.append("nombreArchivo", data.nombreAchivo);
    return this.httpClient.post<DocumentosParentesco>(
      this.SERVER_URL + this.financiamiento + "/documentosParentesco",
      formData
    );
  }
  */

  public getDescargarArchivo(data: any) {
    const formData = new FormData();
    formData.append("nombreArchivo", data.nombreAchivo);
    /*
    const httpOptions = {
      'responseType'  : 'arraybuffer' as 'json'
       //'responseType'  : 'blob' as 'json'        //This also worked
    };
    */
    return this.httpClient.post<DocumnetoAdjunto>(
      this.SERVER_URL + this.financiamiento + "/buscarDocumentoAdjunto",
      formData,
      //formData, {'responseType':'arraybuffer' as 'json'}
      /*,
      httpOptions*/
    );
  }

  public getValidaConFinanciamiento(data: any) {
    const formData = new FormData();
    formData.append("numSuministro", data.numSuministro);
    formData.append("tipDocumento", data.tipDocumento);
    formData.append("numDocumento", data.numDocumento);
    formData.append("tipSolicitante", data.tipSolicitante);

    return this.httpClient.post<Retorno>(
      this.SERVER_URL + this.financiamiento + "/validaConFinanciamiento",
      formData
    );
  }

  public getValidaConTramite(data: any) {
    const formData = new FormData();
    formData.append("numSuministro", data.numSuministro);
    formData.append("tipDocumento", data.tipDocumento);
    formData.append("numDocumento", data.numDocumento);
    formData.append("tipSolicitante", data.tipSolicitante);

    return this.httpClient.post<BandejaSolicitante>(
      this.SERVER_URL + this.financiamiento + "/validaConTramite",
      formData
    );

  }

  public getBandeja(data: any) {
    const formData = new FormData();
    formData.append("numSuministro", data.nis_rad,);
    formData.append("tipDocumento", data.tip_doc,);
    formData.append("numDocumento", data.dni,);
    formData.append("tipSolicitante", data.tip_sol);
    return this.httpClient.post<BandejaSolicitante>(
      this.SERVER_URL + this.financiamiento + "/bandeja", formData);
  }

  public getBandejaDocs(data: any) {
    const formData = new FormData();
    formData.append("numSuministro", data.numSuministro);
    formData.append("tipDocumento", data.tipDocumento);
    formData.append("numDocumento", data.numDocumento);
    formData.append("tipSolicitante", data.tipSolicitante);
    return this.httpClient.post<BandejaDocumentos>(
      this.SERVER_URL + this.financiamiento + "/bandejaDocumentos", formData);
  }

  public getMesesAdeudados(request: any) {
    const url = environment.financiamiento_api + "/acuerdos/consulta";
    return this.httpClient.post(url, request);
  }

  public calcularCuotas(request: any) {
    const url = environment.financiamiento_api + "/acuerdos/calculacuotas";
    return this.httpClient.post(url, request);
  }

  public grabarCuotas(request: any) {
    const url = environment.financiamiento_api + "/acuerdos/grabarcuotas";
    //return this.httpClient.put(url, request);
    return this.httpClient.post(url, request);
  }

  public consultaEstado(
    numSuministro: any,
    tipDocumento: any,
    numDocumento: any,
    idBandeja: any
  ) {
    const url =
      this.SERVER_URL +
      `/seguimiento-tramite/consultaEstado?numSuministro=${numSuministro}&tipDocumento=${tipDocumento}&numDocumento=${numDocumento}&idBandeja=${idBandeja}`;
    return this.httpClient.get(url);
  }

  public registrarSolicitante(request: any) {
    const url =
      this.SERVER_URL + `/financiamiento/reusable/registrarSolicitante`;
    return this.httpClient.post(url, request);
  }

  public actualizaSolicitante(request: any) {
    const url =
      this.SERVER_URL + `/financiamiento/reusable/actualizaSolicitante`;
    return this.httpClient.post(url, request);
  }

  public registrarArchivosTemporal(request: any) {
    const url =
      this.SERVER_URL + `/financiamiento/reusable/registrarArchivosTemporal`;
    return this.httpClient.post(url, request);
  }

  public financiamientoRealizado(request: any) {
    const url =
      this.SERVER_URL + `/notificacionesCorreo/solicitante/financiamientoRealizado`;
    return this.httpClient.post(url, request);
  }

  public documentopdfRealizado(request: any) {
    const url =
      this.SERVER_URL + `/notificacionesCorreo/descargarConvenio`;
    return this.httpClient.post(url, request);
  }

  public actualizarDocumentos(
    idBandeja: any,
    idBandejaDoc: any,
    nombreArchivo: any,
    estadoDocumento: any,
    formData: any
  ) {
    const url =
      this.SERVER_URL +
      `/seguimiento-tramite/actualizarDocumentos?idBandeja=${idBandeja}&idBandejaDoc=${idBandejaDoc}&nombreArchivo=${nombreArchivo}&estadoDocumento=${estadoDocumento}`;
    return this.httpClient.put(url, formData);
  }

  public eliminarDocumentos(data: any) {
    const formData = new FormData();
    formData.append("idBandeja", data.idBandeja);
    formData.append("idBandejaDoc", data.idBandejaDoc);
    formData.append("nombreArchivo", data.nombreArchivo);
    formData.append("estadoDocumento", data.estadoDocumento);

    const url = this.SERVER_URL + `/seguimiento-tramite/eliminarDocumentos`;
    return this.httpClient.post(url, formData);
  }

  public verdocumento(
    idBandeja: any,
    idBandejaDoc: any,
    docAdjunto: any,
    estadoDocumento: any
  ) {
    const url =
      this.SERVER_URL +
      `/seguimiento-tramite/verDocumentos?idBandeja=${idBandeja}&idBandejaDoc=${idBandejaDoc}&docAdjunto=${docAdjunto}&estadoDocumento=${estadoDocumento}`;
    return this.httpClient.get(url);
  }

  public actualizarDatosFinancimiento(request: any) {
    const url = this.SERVER_URL + `/financiamiento/reusable/actualizarDatos`;
    return this.httpClient.post(url, request);
  }

  public validarActualizarDatosFinancimiento(request: any) {
    const url = this.SERVER_URL + `/financiamiento/reusable/validaActualizarDatos`;
    return this.httpClient.post(url, request);
  }

  public validarFileServerFinancimiento(request: any) {
    const url = this.SERVER_URL + `/notificacionesCorreo/conexionFileServer?idSuministro=${request.idSuministro}`;
    return this.httpClient.get<DocumnetoAdjunto>(url);
  }

  public descargarConvenio(
    nombreArchivo: any,
    bandejaId: any,
    suministro: any,
    tipoDocumento: any,
    numDocumento: any,
    correo_solicitante: any
  ) {
    const url =
      this.SERVER_URL +
      `/seguimiento-tramite/verDocumentos?nombreArchivo=${nombreArchivo}&bandejaId=${bandejaId}&suministro=${suministro}&tipoDocumento=${tipoDocumento}&numDocumento=${numDocumento}&correo_solicitante=${correo_solicitante}`;
    return this.httpClient.get<DocumnetoAdjunto>(url);

  }

  public enviarRechazado(
    idBandeja: any,
    formData: any
  ) {
    const url =
      this.SERVER_URL +
      `/financiamiento/reusable/actualizarBandejaRechazado?idBandeja=${idBandeja}`;
    return this.httpClient.post<ResponseBack>(url, formData);
  }

  public validarSolicitante(numSuministro: number, tipDocumento: string, numDocumento: string, caso: number) {
    return this.httpClient.get(this.SERVER_URL + `/financiamiento/validar/solicitante/${numSuministro}/${tipDocumento}/${numDocumento}/${caso}`);
  }

}
